<template>
    <div class="filter-side scrollable">
        <div class="filters-header">
            <h4>Sessions</h4>
            <!-- <div class="reset-filters"><i class="os-icon-close os-icon"></i><span>Reset Filters</span></div> -->
        </div>
        <div class="ae-list-w middle">
            <div class="ae-list">
                <div class="ae-item" v-for="session in sessions.data" :class="checkActiveClass(session)" @click="onSelectSession(session)">
                    <div class="aei-image" v-if="session.avatar">
                        <div class="user-avatar-w"><img alt="" :src="session.avatar"></div>
                    </div>
                    <div class="aei-content">
                        <div class="aei-timestamp">{{session.created_at}}</div>
                        <h6 class="aei-title">{{session.code}}</h6>
                        <div class="aei-sub-title">{{session.name}}</div>
                        <div class="aei-sub-title">{{session.channel_name || '--'}}</div>
                        <div class="aei-sub-title">{{session.type || '--'}} Session</div>
                        <div class="aei-sub-title"><b>{{(session.products - session.dropped_count) || '--'}}</b> Products</div>

                        <!-- <div class="aei-sub-title">Session {{product.id_photodesk_session || product.id_pretouchdesk_session}}</div>
                    <div class="aei-text" v-if="product.type">{{product.type}} Shoot</div>
                    <div class="aei-text" v-if="product.date_received">Received {{product.date_received}}</div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['sessions', 'selectedSession'],
  methods: {
    onSelectSession: function (session) {
      this.$emit('sessionRailInterface', session)
    },
    checkActiveClass: function (session) {
      if (this.selectedSession != null) {
        return session.id_photodesk_session ==
          this.selectedSession.id_photodesk_session
          ? 'active'
          : ''
      }
    }
  }
}
</script>

<style scoped>
h6,
.h6 {
  font-size: 1rem !important;
}
.aei-content {
  width: 100%;
}
.aei-timestamp {
  color: #047bf8 !important;
}
.ae-list-w .ae-list .aei-image .user-avatar-w img {
  border-radius: 0px;
}
.ae-list-w .ae-list .ae-item.active .user-avatar-w {
  border-radius: 0px;
}
</style>
